import { readLayerListEntryUuid } from './inventory-raw-readers';
import { fromBaseUuid } from './from-base-context';
import { isPhpNumeric, roundPhpDecimal } from './php-decimal-values';
import { phpJsonTruthy } from './php-json-values';

type Row = Record<string, unknown>;

/** ft_apply_object_vitality's maximum; null leaves the template's existing vitality alone. */
export function objectVitalityMax(row: Row, readers: { layerValue: (row: Row | null, name: string) => unknown },
    scaleOf: (size: unknown) => unknown, material: (id: string) => Row | null): number | null {
    if (!phpJsonTruthy(readers.layerValue(row, 'item_composition'))
        || phpJsonTruthy(readers.layerValue(row, 'v_max_override'))) return null;
    const scale = scaleOf(readers.layerValue(row, 'size'));
    const materialId = readLayerListEntryUuid(readers.layerValue(row, 'item_composition'));
    const composition = fromBaseUuid(materialId) ? material(materialId) : null;
    const multiplier = readers.layerValue(composition, 'object_vitality_multiplier');
    const authored = readers.layerValue(row, 'v_max');
    return Math.max(1, roundPhpDecimal(isPhpNumeric(authored) && Number(authored) > 0 ? Number(authored)
        : 10 * Number(scale ?? 1) * (isPhpNumeric(multiplier) && Number(multiplier) > 0 ? Number(multiplier) : 1), 0));
}
